import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import PrimeVue from "primevue/config";
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "./assets/styles/tailwind.css";
import Tooltip from "primevue/tooltip";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Chart from 'primevue/chart';
import YouTube from 'vue3-youtube'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import { installPrimevueDropdownNoJump } from './utils/primevueDropdownNoJump';

installPrimevueDropdownNoJump();

createApp(App)
  .use(router)
  .use(PrimeVue)
  .use(VueSweetalert2)
  .use(VueGoogleMaps, {
      load: {
          key: 'AIzaSyBMxcpHHv8U4kBGWF5aeK93FrbMj3TrVMk',
      },
  })
  .component('Chart', Chart)
  .component('YouTube', YouTube)
  .directive("tooltip", Tooltip)
  .mount("#app");
